import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

import { readFile, readFiles, readFileIntoBlobUrl } from "../services/fileApi";

export function useFileQuery(id, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["file", id],
    queryFn: () => readFile(id),
    enabled: isOpen && !!id,
    gcTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useFilesQuery({ entity_type = null, entity_id = null } = {}, enabled = true) {
  const params = {
    ...(entity_type && { entity_type }),
    ...(entity_id && { entity_id }),
  };

  return useQuery({
    queryKey: ["files", params],
    queryFn: () => readFiles(params),
    enabled: enabled && !!entity_id,
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useFileIntoBlobUrl(id, isOpen) {
  const { t } = useTranslation();
  const { data: blobUrl, ...query } = useQuery({
    queryKey: ["fileBlobUrl", id],
    queryFn: () => readFileIntoBlobUrl(id),
    enabled: isOpen && !!id,
    gcTime: 0, // Don't cache blob URLs
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });

  // Clean up blob URL on unmount or when id changes
  useEffect(() => {
    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [blobUrl]);

  return { blobUrl, ...query };
}
